import React from 'react';
import AvatarIcon from 'icons/avatar';

interface Props {
  showAvatar: boolean;
}

const Avatar: React.FC<Props> = ({ showAvatar }) => {
  return <>{showAvatar ? <AvatarIcon /> : <div style={{ width: '45px' }} />}</>;
};

export default Avatar;
